{
  "slug": "iq-score-ranges-explained",
  "title": "आईसीसी टूर्नामेंट्स रेटिंग",
  "description": "सामान्य आईक्यू स्कोर बैंड, अनुमानित प्रतिशत, विश्वसनीय अंतराल और लेबल की सीमाओं का पता लगाएं।",
  "summary": "IQ स्कोर बैंड सुविधाजनक सारांश हैं, लेकिन सीमाएँ और लेबल परीक्षा के अनुसार भिन्न होते हैं. स्कोर को अनुमानों के रूप में और संदर्भ में समझा जाना चाहिए.",
  "sections": [
    {
      "heading": "सामान्य रेखाओं के लिए एक व्यावहारिक मार्गदर्शक",
      "paragraphs": [
        "के औसत के साथ एक पैमाने के लिए 100 और मानक विचलन है 15, ये बैंड सामान्य दिशा प्रदान करते हैं. वे निदान श्रेणियाँ नहीं हैं."
      ],
      "bullets": [
        "130 और ऊपर: लगभग शीर्ष 2%",
        "120–129: लगभग 91st–9710वां प्रतिशत",
        "110–119: लगभग 75थ9010वां प्रतिशत",
        "90–109: चौड़ी मध्य सीमा",
        "80–89: लगभग 9थ2410वां प्रतिशत",
        "70–79: लगभग 2एनडी-810वां प्रतिशत",
        "नीचे 70: लगभग न्यूनतम 2%"
      ]
    },
    {
      "heading": "लेबल क्यों भिन्न हैं",
      "paragraphs": [
        "प्रकाशन और संस्थान अलग-अलग शर्तों और कटऑफ का उपयोग करते हैं. एक सीमा पर एक परिणाम एक बिंदु दूर एक से अर्थपूर्ण रूप से अलग नहीं है, और भरोसेमंद अंतराल अक्सर एक से अधिक बैंडों को पार करते हैं।",
        "उच्च या निम्न परिणामों को केवल कुल से ही समझा नहीं जाना चाहिए. एक पेशेवर अनुकूलनात्मक कार्य, विकास, शिक्षा और भाषा को प्रासंगिक मानता है।"
      ]
    },
    {
      "heading": "प्रोफ़ाइल पढ़ें, न कि सिर्फ संख्या",
      "paragraphs": [
        "एक ही कुल अंक के दो लोगों की अलग-अलग ताकत हो सकती है. एक मौखिक तर्क में बेहतर हो सकता है जबकि दूसरा दृश्य पैटर्न पर बेहतर प्रदर्शन करता है. एक मिश्रण इन अंतरों को छुपा सकता है.",
        "एक ऑनलाइन स्कोर को विशेष परिस्थितियों में एक स्नैपशॉट के रूप में उपयोग करें, एक स्थायी लेबल नहीं।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQ को उच्च माना जाता है।",
      "answer": "कई पैमाने पर, 120 या ऊपर है अच्छी तरह से औसत से ऊपर और 130 या ऊपर शीर्ष के आसपास है 2%, लेकिन शब्दावली भिन्न होती है."
    },
    {
      "question": "क्या IQ सीमाएं सटीक हैं?",
      "answer": "विभिन्न प्रकार के द्रव्यमान और विभिन्न प्रकार के द्रव्यमान के गुणांकों के योग से द्रव्यमान का मान निकाला जाता है।"
    }
  ],
  "related": [
    "what-is-the-average-iq",
    "what-does-an-iq-of-120-mean",
    "what-does-an-iq-of-140-mean"
  ]
}
